import React from "react";
import { FormGroup } from "reactstrap";
import UserPicker from "../../../partials/user-manage/UserPicker";
import { contactPersonEmailFromUser } from "../../../../utils/medicalPartnerPrimaryUser";
import { filterUserAssignableAsPrimaryPartner } from "../medicalPartnerListTableHelpers";

const EditMedicalPartnerPrimaryUserField = ({ filterPartner, value, onChange, disabled, idPrefix = "edit-partner-primary-user" }) => {
  const email = value ? contactPersonEmailFromUser(value) : "";

  return (
    <div className="border rounded px-3 py-3 bg-lighter">
      <h6 className="overline-title text-primary mb-2">Primary account (required)</h6>
      <p className="text-soft small mb-3">
        Pick a real directory user — login and contact identity on the partner record follow this account when you save the Partner tab (not typed
        separately here).
      </p>
      {!value ? <p className="small text-warning mb-2">No primary user selected — search below before saving.</p> : null}
      {value && !email ? (
        <div className="alert alert-warning py-2 mb-2 small" role="status">
          This user has no email on file. Add one on the user profile before saving.
        </div>
      ) : null}
      <FormGroup className="mb-0">
        <UserPicker
          idPrefix={idPrefix}
          value={value}
          onChange={onChange}
          disabled={disabled}
          filterCandidate={(u) => filterUserAssignableAsPrimaryPartner(u, filterPartner)}
          placeholder="Search by email or name…"
          emptyHint="No eligible users found — create the account under Users first."
        />
      </FormGroup>
    </div>
  );
};

export default EditMedicalPartnerPrimaryUserField;
